/**
 * Map a thrown task mutation error to a user-visible toast string.
 * Prefer API/body message when present; never invent "Coming soon" for real failures.
 */
export function taskActionErrorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === 'object') {
    const ax = err as {
      response?: { data?: { message?: unknown } };
      message?: unknown;
    };
    const apiMsg = ax.response?.data?.message;
    if (typeof apiMsg === 'string' && apiMsg.trim()) return apiMsg.trim();
    if (typeof ax.message === 'string' && ax.message.trim()) return ax.message.trim();
  }
  return fallback;
}
